webpackJsonp([4,30],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_utils_js__ = __webpack_require__(7);




var FormTest = function FormTest() {
  return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 31));
};
var AttachConferenceDemo = function AttachConferenceDemo() {
  return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 30));
};
var VideoPlayer = function VideoPlayer() {
  return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 29));
};

__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/conferenceDemo',
    name: 'conference-demo',
    component: AttachConferenceDemo
  }, {
    path: '/gallery',
    name: 'demo-gallery',
    component: VideoPlayer
  }, {
    path: '/formtest',
    name: 'form-test',
    component: FormTest
  }, {
    path: '/player/:env/:id',
    name: 'attach-player',
    component: VideoPlayer
  }, {
    path: '/convert/:env/:id',
    name: 'attach-convert-player',
    component: VideoPlayer
  }, {
    path: '/:id',
    name: 'attach-universal-link',
    component: VideoPlayer
  }, {
    path: '/desktop/player/:env/:id',
    name: 'attach-player-desktop',
    component: VideoPlayer
  }]
});

/***/ }),
/* 3 */,
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex_router_sync__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_App__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_touch__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_touch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_touch__);
/* unused harmony reexport router */
/* unused harmony reexport store */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return app; });
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_vue_touch___default.a, { name: 'v-touch' });

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */]);

var app = new __WEBPACK_IMPORTED_MODULE_0_vue___default.a(_extends({ router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */], store: __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */] }, __WEBPACK_IMPORTED_MODULE_2__components_App___default.a));



/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_promise_polyfill__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_promise_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_promise_polyfill__);


window.Promise = window.Promise || __WEBPACK_IMPORTED_MODULE_0_promise_polyfill___default.a;

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_offline_plugin_runtime__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_offline_plugin_runtime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_offline_plugin_runtime__);


__WEBPACK_IMPORTED_MODULE_0_offline_plugin_runtime___default.a.install({
  // When an update is ready, tell ServiceWorker to take control immediately:
  onUpdateReady: function onUpdateReady() {
    console.log('update ready');
    __WEBPACK_IMPORTED_MODULE_0_offline_plugin_runtime___default.a.applyUpdate();
  },


  // Reload to get the new version:
  onUpdated: function onUpdated() {
    console.log('updated');
    // location.reload()
  }
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// All of our hostnames.
var isLocalHost = function isLocalHost() {
  return window.location.host.search('localhost') >= 0;
};
var stagingHostName = function stagingHostName() {
  return 'attach-alpha.mikmak.tv';
};
var bananaRepublicHostName = function bananaRepublicHostName() {
  return 'attach-demo.mikmak.tv';
};
var secureStagingHostName = function secureStagingHostName() {
  return 'attach-dev.mikmak.tv';
};
var productionHostName = function productionHostName() {
  return 'attach.mikmak.tv';
};
var betaHostName = function betaHostName() {
  return 'beta.mikmak.tv';
};
var drBrandtHostName = function drBrandtHostName() {
  return 'drbrandt.mikmak.tv';
};
var secureProductionHostName = function secureProductionHostName() {
  return 'attach-prod.mikmak.tv';
};

// Production attach, but ignore traffic and events because it is a visual test.
var isVisualTest = window.location.search.indexOf('internalVisualTest') != -1;
var isTestPurchase = window.location.search.indexOf('testpurchase') != -1;
var noPlayDemo = window.location.search.indexOf('noPlayDemo') != -1;

var isGalleryView = window.location.href.indexOf('.mikmak.tv/gallery') != -1;

// Determine if current env is Production or not.
var isProduction = function isProduction() {
  if (isDesktop()) return false;
  if (isVisualTest) return false;

  var host = window.location.host;
  return host == productionHostName() || host == drBrandtHostName() || host == secureProductionHostName() || host == bananaRepublicHostName() || host == betaHostName();
};

// We run tests using Phantom JS. User agent will be electron. We
// have to fire events in prod, but we want to be able to mark them as test.
var isTestEvent = function isTestEvent() {
  return window.navigator.userAgent.search('Electron') != -1;
};

// See if a social media ID is in user agent.
var isInstagram = window.navigator.userAgent.search('Instagram') != -1;
var isFacebook = window.navigator.userAgent.search('FBAN') != -1 || window.navigator.userAgent.search('FBAV') != -1;
var isSnapchat = window.navigator.userAgent.search('Snapchat') != -1;
var isAndroid = window.navigator.appVersion.search('Android') != -1;
var isInternetExplorer = window.navigator.userAgent.search('Explorer') != -1 || window.navigator.userAgent.search('Edge') != -1;

// Determine if client is visiting from Desktop.
var isDesktop = function isDesktop() {
  var isDesktop = true;

  if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) isDesktop = false;

  if (window.navigator.platform == 'MacIntel') isDesktop = true;
  if (window.navigator.platform == 'Windows') isDesktop = true;

  return isDesktop;
};

var s4 = function s4() {
  return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
};
var guid = function guid() {
  return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
};

var getCurrentDate = function getCurrentDate() {
  var d = new Date();
  var yr = d.getFullYear();
  var mo = d.getMonth() + 1;
  if (mo < 10) mo = '0' + String(mo);
  var day = d.getDate();
  if (day < 10) day = '0' + String(day);

  return '' + yr + mo + day;
};

var sortByKey = function sortByKey(array, key) {
  return array.sort(function (a, b) {
    var x = a[key];var y = b[key];
    return x > y ? -1 : x < y ? 1 : 0;
  });
};

var sortArrayByDate = function sortArrayByDate(array, key) {
  return array.sort(function (a, b) {
    var x = new Date(a[key]);
    var y = new Date(b[key]);
    return x > y ? -1 : x < y ? 1 : 0;
  });
};

var sortArrayByNumber = function sortArrayByNumber(array, key) {
  return array.sort(function (a, b) {
    var y = Number(a[key]);
    var x = Number(b[key]);
    return x > y ? -1 : x < y ? 1 : 0;
  });
};

var getConstantKeyFromStore = function getConstantKeyFromStore(state, key) {
  var constants = state.constants;
  var text = constants[key].default;
  if (state.currentPlayerLanguage) {
    var language = state.currentPlayerLanguage;
    if (constants[key][language]) {
      text = constants[key][language];
    }
  }

  return text;
};

// Is the app currently visible to the user or not?
var appIsHidden = function appIsHidden() {
  if (document.hidden) return true;
  if (document.webkitHidden) return true;
  if (document.msHidden) return true;

  return false;
};

// Get version of IOS.
var iOSversion = function iOSversion() {
  var appVersion = window.navigator.appVersion;
  var versionString = appVersion.split('iPhone OS ')[1];
  if (!versionString) return undefined;
  versionString = versionString.split(' ')[0];
  var versionArray = versionString.split('_');

  return versionArray;
};

// Get version of Instagram.
var instagramVersion = function instagramVersion() {
  var ua = window.navigator.userAgent;
  var igv = ua.split('Instagram')[1];
  if (igv) {
    if (igv.indexOf('iPhone') > -1 || igv.indexOf('Android') > -1) {
      igv = igv.split('(')[0];
      igv = igv.split('.');

      return igv[0] + '.' + igv[1];
    }

    return undefined;
  } else {
    return undefined;
  }
};

// Check if Instagram Version is 28 or Higher
var instagramVersion28OrHigher = function instagramVersion28OrHigher() {
  if (!instagramVersion()) return undefined;
  if (parseInt(instagramVersion()) >= 28) return true;
};

var isIphoneXInInstagram = function isIphoneXInInstagram() {
  var ua = window.navigator.userAgent;
  var igv = ua.split('Instagram')[1];
  if (igv) {
    if (ua.indexOf('iPhone10') >= 0) {
      // iPhone10 appears for both iPhone 8 and iPhone X, ensure dimensions
      // are correct for iPhone X.
      if (ua.indexOf('1125x2436') >= 0) return true;

      return false;
    }
    return undefined;
  } else {
    return undefined;
  }
};

var validateEmail = function validateEmail(email) {
  var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
};

var removeProtocolFromUrl = function removeProtocolFromUrl(url) {
  url = url.replace('https:', '');
  url = url.replace('http:', '');

  return url;
};

var slugify = function slugify(text) {
  return text.toString().toLowerCase().replace(/\s+/g, '-') // Replace spaces with -
  .replace(/[^\w\-]+/g, '') // Remove all non-word chars
  .replace(/\-\-+/g, '-') // Replace multiple - with single -
  .replace(/^-+/, '') // Trim - from start of text
  .replace(/-+$/, ''); // Trim - from end of text
};

var getQueryParam = function getQueryParam(searchKey) {
  var match = void 0;
  var queryParams = window.location.search;

  queryParams.split('%26').join('&');
  queryParams.split('%3D').join('=');

  if (queryParams && queryParams[0] == '?') {
    queryParams = queryParams.substring(1);

    var pairArray = queryParams.split('&');
    pairArray.map(function (pair) {
      var key = pair.split('=')[0];
      var value = pair.split('=')[1];
      if (key == searchKey) {
        match = value;
      }
    });
  }

  return match;
};

var getIOSWindowHeight = function getIOSWindowHeight() {
  var zoomLevel = document.documentElement.clientWidth / window.innerWidth;

  return window.innerHeight * zoomLevel;
};

var getHeightOfIOSToolbars = function getHeightOfIOSToolbars() {
  var tH = (window.orientation === 0 ? screen.height : screen.width) - getIOSWindowHeight();

  return tH > 1 ? tH : 0;
};

var cartPlatformCheck = function cartPlatformCheck(cartSlug, state) {
  if (state.currentMulticartRetailer) {
    if (state.currentMulticartRetailer == cartSlug) {
      return true;
    } else {
      return false;
    }
  }
  if (state.currentFocusedProduct && state.currentFocusedProduct.cartPlatform) {
    return state.currentFocusedProduct.cartPlatform == cartSlug;
  }
  if (state.currentPlayer.cartPlatform && !state.currentFocusedProduct.cartPlatform) {
    return state.currentPlayer.cartPlatform == cartSlug;
  }
  return false;
};

var BAXTER_BENCHMARK_TEST = function BAXTER_BENCHMARK_TEST(playerId) {
  if (!isProduction()) return false;
  if (playerId == '23d74c95-b53d-4447-a6a1-fc6f5c8e0fc5' || playerId == '1ff853fe-3575-73e0-6f5d-57f5042b4fbe' || playerId == 'e43300f9-00d7-dc9c-0a0a-c4637d07fd26' || playerId == '4dc0c86b-d1d0-bec0-e684-cc67a14c5c20') {
    var diceRoll = Math.random().toFixed(1);
    if (diceRoll <= 0.1) return true;
  }

  return false;
};

var NESQUICK_BENCHMARK_TEST = function NESQUICK_BENCHMARK_TEST(playerId) {
  if (!isProduction()) return false;
  if (playerId == 'e37d6218-73db-22f7-6553-b36eb494c2b1' || playerId == '78574513-4adf-64f4-7e16-95f04de48f7e' || playerId == '3e06e127-da8f-db38-820d-6bf061b7adf8') {
    var diceRoll = Math.random().toFixed(1);
    if (diceRoll <= 0.1) return true;
  }

  return false;
};

/* harmony default export */ __webpack_exports__["a"] = {
  isProduction: isProduction,
  isDesktop: isDesktop,
  isLocalHost: isLocalHost,
  getCurrentDate: getCurrentDate,
  isInstagram: isInstagram,
  isFacebook: isFacebook,
  isSnapchat: isSnapchat,
  isAndroid: isAndroid,
  isInternetExplorer: isInternetExplorer,
  isVisualTest: isVisualTest,
  isTestPurchase: isTestPurchase,
  noPlayDemo: noPlayDemo,
  isGalleryView: isGalleryView,
  getConstantKeyFromStore: getConstantKeyFromStore,
  appIsHidden: appIsHidden,
  hosts: {
    staging: stagingHostName(),
    secureStaging: secureStagingHostName(),
    production: productionHostName(),
    drbrandt: drBrandtHostName(),
    secureProduction: secureProductionHostName()
  },

  isTestEvent: isTestEvent,
  guid: guid,
  sortByKey: sortByKey,
  sortArrayByDate: sortArrayByDate,
  sortArrayByNumber: sortArrayByNumber,

  iOSversion: iOSversion,
  instagramVersion: instagramVersion,
  isIphoneXInInstagram: isIphoneXInInstagram,
  instagramVersion28OrHigher: instagramVersion28OrHigher,
  validateEmail: validateEmail,
  removeProtocolFromUrl: removeProtocolFromUrl,
  slugify: slugify,
  getQueryParam: getQueryParam,
  getHeightOfIOSToolbars: getHeightOfIOSToolbars,
  getIOSWindowHeight: getIOSWindowHeight,
  cartPlatformCheck: cartPlatformCheck,
  NESQUICK_BENCHMARK_TEST: NESQUICK_BENCHMARK_TEST,
  BAXTER_BENCHMARK_TEST: BAXTER_BENCHMARK_TEST
};

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__brandLogosDictionary__ = __webpack_require__(10);






__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var state = {

  // Product Options configs
  selectedPrimaryOption: undefined,
  selectedSecondaryOption: undefined,
  childOptionsForPrimaryOption: undefined,
  primaryProductId: undefined,
  secondaryProductId: undefined,

  // Player-state configs
  environment: '',
  currentPlayerId: undefined,
  currentPlayer: undefined,
  currentPlayerType: undefined,
  currentPlayerProducts: [],
  currentPlayerVideos: [],

  // Cart-state configs
  cart: [],
  currentMulticartRetailer: undefined,
  currentRetailerCart: undefined,
  checkoutUrl: undefined,
  shopifyUrl: undefined,
  checkoutInProgress: undefined,

  // DOM globals
  videoWrapperId: 'video-element-wrapper',
  videoElementId: 'video-player-element',

  // Gallery view config for uploading sample demo video.
  galleryVideoOverride: undefined,

  brandLogosDictionary: __WEBPACK_IMPORTED_MODULE_4__brandLogosDictionary__["a" /* default */],

  // State configs
  showMultiCardAddOptions: false,
  productsLockedToVideos: false,
  currentVideoCanPlay: undefined,
  currentVideoIndex: 0,
  currentProductIndex: 0,
  currentFocusedProduct: undefined,
  loopVideos: false,
  muted: true,
  infoBoxVisible: false,
  focusedProductImage: undefined,
  checkoutButtonActive: false,
  constants: __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */],
  currentVideo: undefined,
  currentPlayerLanguage: undefined,
  currentBrand: undefined,
  storePlayerTouched: undefined,
  emailModalShowing: false,
  emailModalHasAppeared: false,
  forceShowEmailModal: false,
  totalRatingsSubmitted: 0,
  totalReviewsRated: 0,
  totalReviewsRead: 0,
  ratePlayerInfiniteMode: false,
  rateCtaIndex: 0,
  showOptions: false,
  addedToCartState: false,
  showInternetExplorerWarning: false,
  showDisclaimerText: false
};

var mutations = {
  toggleDisclaimerText: function toggleDisclaimerText(state, toggle) {
    state.showDisclaimerText = toggle;
  },
  markCheckoutAsInProgress: function markCheckoutAsInProgress() {
    state.checkoutInProgress = true;
  },
  updateGalleryVideoOverride: function updateGalleryVideoOverride(state, videoUrl) {
    state.galleryVideoOverride = videoUrl;
  },
  setCurrentMulticartRetailer: function setCurrentMulticartRetailer(state, cart) {
    state.currentMulticartRetailer = cart;
  },
  updateCurrentVideoCanPlay: function updateCurrentVideoCanPlay(state, canPlay) {
    state.currentVideoCanPlay = canPlay;
  },
  setCurrentRetailerCart: function setCurrentRetailerCart(state, cart) {
    state.currentRetailerCart = cart;
  },
  setCheckoutUrl: function setCheckoutUrl(state, url) {
    state.checkoutUrl = url;
  },
  setShopifyUrl: function setShopifyUrl(state, url) {
    state.shopifyUrl = url;
  },
  incrementCurrentVideoIndex: function incrementCurrentVideoIndex() {
    var currentIndex = state.currentVideoIndex;
    currentIndex++;

    if (currentIndex > state.currentPlayerVideos.length - 1) currentIndex = 0;

    updateVideoDetails(currentIndex);
  },
  decrementCurrentVideoIndex: function decrementCurrentVideoIndex() {
    var currentIndex = state.currentVideoIndex;
    currentIndex--;

    if (currentIndex < 0) currentIndex = state.currentPlayerVideos.length - 1;

    updateVideoDetails(currentIndex);
  },
  updateLoopVideoSettings: function updateLoopVideoSettings(state, loopVideos) {
    state.loopVideos = loopVideos;
  },
  setMute: function setMute(state, muted) {
    state.muted = muted;
  },
  toggleMute: function toggleMute() {
    state.muted = !state.muted;
  },
  toggleMultiCardAddOptions: function toggleMultiCardAddOptions(state, showOptions) {
    state.showMultiCardAddOptions = showOptions;
  },
  setInfoBoxVisible: function setInfoBoxVisible(state, isVisible) {
    state.infoBoxVisible = isVisible;
  },
  setFocusedProductImage: function setFocusedProductImage(state, image) {
    state.focusedProductImage = image;
  },
  setCheckoutButton: function setCheckoutButton(state, active) {
    state.checkoutButtonActive = active;
  },
  setCurrentPlayer: function setCurrentPlayer(state, player) {
    state.currentPlayer = player;
    state.currentPlayerVideos = player.videos;
    state.currentPlayerType = player.playerType;
    state.currentPlayerLanguage = player.language;

    if (player.products) {
      state.currentPlayerProducts = player.products;
    } else {
      state.currentPlayerProducts = player.videos;
    }

    if (player.videos && player.videos[0]) {
      state.currentVideo = player.videos[0];
    }

    state.currentFocusedProduct = state.currentPlayerProducts[state.currentProductIndex];
    state.addedToCartState = false;

    if (state.currentPlayerType == 'standard' && state.currentPlayerProducts.length > 1) {
      state.productsLockedToVideos = true;
    }
  },
  setCurrentFocusedProduct: function setCurrentFocusedProduct(state, product) {
    state.currentFocusedProduct = product;
  },
  setCurrentPlayerId: function setCurrentPlayerId(state, id) {
    state.currentPlayerId = id;
  },
  setCurrentEnvironment: function setCurrentEnvironment(state, environment) {
    state.environment = environment;
  },
  forceShowEmailModal: function forceShowEmailModal(state, show) {
    state.forceShowEmailModal = show;
  },
  incrementTotalRatingsSubmitted: function incrementTotalRatingsSubmitted() {
    state.totalRatingsSubmitted++;
  },
  incrementTotalReviewsRated: function incrementTotalReviewsRated() {
    state.totalReviewsRated++;
  },
  incrementTotalReviewsRead: function incrementTotalReviewsRead() {
    state.totalReviewsRead++;
  },
  setCurrentProductIndex: function setCurrentProductIndex(state, index) {
    state.currentProductIndex = index;
    state.currentFocusedProduct = state.currentPlayerProducts[state.currentProductIndex];
    state.addedToCartState = false;
  },
  updateProduct: function updateProduct(state, productData) {
    var index = productData.index;
    var product = productData.product;
    state.currentPlayer.products[index] = product;
    state.currentPlayerProducts[index] = product;
    state.currentFocusedProduct = state.currentPlayerProducts[state.currentProductIndex];
  },
  expandStorePlayerCards: function expandStorePlayerCards() {
    state.storePlayerTouched = true;
  },
  collapseStorePlayerCards: function collapseStorePlayerCards() {
    state.storePlayerTouched = false;
  },
  toggleEmailModal: function toggleEmailModal(state, visible) {
    state.emailModalShowing = visible;
    if (visible) state.emailModalHasAppeared = true;
  },
  updateRateCtaIndex: function updateRateCtaIndex(state, integer) {
    state.rateCtaIndex = integer;
  },
  setCurrentBrand: function setCurrentBrand(state, brand) {
    state.currentBrand = brand;
  },
  addItemToCart: function addItemToCart(state, item) {
    state.cart.push(item);
  },
  setSelectedPrimaryOption: function setSelectedPrimaryOption(state, opt) {
    state.selectedPrimaryOption = opt;
  },
  setPrimaryProductId: function setPrimaryProductId(state, id) {
    state.primaryProductId = id;
  },
  setSecondaryProductId: function setSecondaryProductId(state, id) {
    state.secondaryProductId = id;
  },
  setChildOptionsForPrimaryOption: function setChildOptionsForPrimaryOption(state, optionArray) {
    state.childOptionsForPrimaryOption = optionArray;
  },
  setSelectedSecondaryOption: function setSelectedSecondaryOption(state, opt) {
    state.selectedSecondaryOption = opt;
  },
  setShowOptions: function setShowOptions(state, isVisible) {
    state.showOptions = isVisible;
  },
  setAddedToCartState: function setAddedToCartState(state, isVisible) {
    state.addedToCartState = isVisible;
  },
  hideInternetExplorerWarning: function hideInternetExplorerWarning() {
    state.showInternetExplorerWarning = false;
  },
  revealInternetExplorerWarning: function revealInternetExplorerWarning() {
    state.showInternetExplorerWarning = true;
  }
};

var updateVideoDetails = function updateVideoDetails(currentIndex) {
  state.checkoutButtonActive = false;
  state.currentVideoIndex = currentIndex;
  state.currentVideo = state.currentPlayerVideos[state.currentVideoIndex];
  if (state.productsLockedToVideos) {
    state.currentProductIndex = currentIndex;
    state.currentFocusedProduct = state.currentPlayerProducts[state.currentProductIndex];
    state.addedToCartState = false;
  }
};

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: state,
  mutations: mutations
});

/* harmony default export */ __webpack_exports__["a"] = store;

/***/ }),
/* 9 */,
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Images live here
// https://console.aws.amazon.com/s3/buckets/mikmak/uploads/2e88caf4-9a47-4535-96d5-6f1696e4db90/?region=us-east-1&tab=overview
/* harmony default export */ __webpack_exports__["a"] = {
  brandsList: ['air-heads', 'american-express', 'b-and-h-photo', 'banana-republic', 'benefit-cosmetics', 'birchbox', 'bose', 'buzzfeed', 'chase', 'dermablend', 'dollar-shave-club', 'dr-brandt', 'estee-lauder', 'general-electric', 'gopro', 'it-cosmetics', 'kate-spade', 'oxygen', 'lancome', 'loreal', 'make-up-for-ever', 'mondelez', 'oreo', 'pandg', 'pepperidge-farm', 'revlon', 'pepsi', 'pureology', 'shea-moisture', 'swedish-fish', 't-mobile', 'under-armour', 'viacom', 'wish', 'unilever', 'zappos']
};

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = {

  'ADD_TO_CART_TEXT': {
    'default': 'Add to Cart on',
    'french': 'Ajouter au panier sur'
  },

  'CURRENCY_CHARACTERS': {
    'default': {
      'preceeding': '$',
      'following': ''
    },
    'french': {
      'preceeding': '',
      'following': '&euro;'
    },
    'united_kingdom': {
      'preceeding': '&pound;',
      'following': ''
    }
  },

  'MORE_INFO_TEXT': {
    'default': 'More Info',
    'french': 'Plus d\'info'
  },

  'CURRENT_PRODUCT_FROM_TEXT': {
    'default': 'from',
    'french': 'de'
  },

  'ADDED_TO_CART_TEXT': {
    'default': '1 item added to cart',
    'french': '1 produit ajouté au panier'
  },

  'KEEP_SHOPPING_TEXT': {
    'default': 'Keep Shopping',
    'french': 'Continuez vos achats'
  },

  'SHOP_THE_LOOK_TEXT': {
    'default': 'Shop the look'
  },

  'COMPLETE_YOUR_PURCHASE_TEXT': {
    'default': 'Complete your purchase on',
    'french': 'Terminer vos achats sur'
  },

  'CHECKOUT_NOW_TEXT': {
    'default': 'Checkout Now',
    'french': 'Acheter maintenant'
  },

  'FORM_IS_SUBMITTING': {
    'default': 'Checking out now'
  },

  'SHOP_NOW_TEXT': {
    'default': 'Shop Now',
    'french': 'Acheter maintenant'
  },

  'POWERED_BY_TEXT': {
    'default': 'powered by',
    'french': 'Réaliser par'
  },

  'COLOR_OPTION_TEXT': {
    'default': 'option',
    'french': 'couleur'
  },

  'SIZE_OPTION_TEXT': {
    'default': 'option',
    'french': 'taille'
  },

  'PLEASE_SELECT_TEXT': {
    'default': 'Please select',
    'french': 'Sélectionnez votre'
  },

  'SELECTED_TEXT': {
    'default': 'selected',
    'french': 'validée'
  },

  'SELECT_ABOVE_TEXT': {
    'default': 'above',
    'french': '&nbsp;'
  }

};

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = {
  beforeCreate: function beforeCreate() {},
  mounted: function mounted() {
    this.loadConditionalAssets();
  },

  computed: {
    currentPlayer: function currentPlayer() {
      return this.$store.state.currentPlayer;
    },
    environment: function environment() {
      return this.$store.state.environment;
    },
    playerType: function playerType() {
      return this.currentPlayer && this.currentPlayer.playerType;
    },
    products: function products() {
      return this.currentPlayer && this.currentPlayer.products;
    }
  },
  methods: {
    loadConditionalAssets: function loadConditionalAssets() {
      if (!this.currentPlayer) return;
      if (!this.playerType) return;

      // Store, with > 1 products uses tiny slider.
      if (this.playerType == 'store') {
        if (this.products && this.products.length > 1) {
          this.loadScript('https://cdnjs.cloudflare.com/ajax/libs/tiny-slider/2.4.0/min/tiny-slider.js');
          this.loadLink('https://cdnjs.cloudflare.com/ajax/libs/tiny-slider/2.4.0/tiny-slider.css');
        }
      }

      // Review and redeem use tiny slider, as well as Font Awesome for icons.
      if (this.playerType == 'review' || this.playerType == 'redeem') {
        this.loadScript('https://use.fontawesome.com/faab3068b6.js');
        this.loadScript('https://cdnjs.cloudflare.com/ajax/libs/tiny-slider/2.4.0/min/tiny-slider.js');
        this.loadLink('https://cdnjs.cloudflare.com/ajax/libs/tiny-slider/2.4.0/tiny-slider.css');
      }

      // Rate uses animate library, as well as Font Awesome for icons.
      if (this.playerType == 'rate') {
        this.loadScript('https://use.fontawesome.com/faab3068b6.js');
        this.loadLink('https://firebasestorage.googleapis.com/v0/b/mikmak-attach-prod.appspot.com/o/animate.min.css?alt=media&token=d5f19583-d89e-42f1-a70e-daf6b5b6aa49');
      }

      if (this.environment == 'snapchat') {
        this.loadScript('https://firebasestorage.googleapis.com/v0/b/mikmak-attach-prod.appspot.com/o/iphone-inline-video.min.js?alt=media&token=02924916-6ba2-4504-ac27-6d317cfa48d4');
        this.loadScript('https://use.fontawesome.com/faab3068b6.js');
      }
    },
    loadScript: function loadScript(src) {
      var script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = src;
      document.getElementsByTagName('head')[0].appendChild(script);
    },
    loadLink: function loadLink(href) {
      var link = document.createElement('link');
      link.type = 'text/css';
      link.rel = 'stylesheet';
      link.href = href;
      document.getElementsByTagName('head')[0].appendChild(link);
    }
  },
  watch: {
    currentPlayer: function currentPlayer() {
      this.loadConditionalAssets();
    }
  }
};

/***/ }),
/* 13 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(13)

var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(12),
  /* template */
  __webpack_require__(20),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 20 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__promise_polyfill__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app__ = __webpack_require__(4);



// Enable progressive web app support (with offline-plugin)
if (true) {
  __webpack_require__(6);
}

__WEBPACK_IMPORTED_MODULE_1__app__["a" /* app */].$mount('#app');

/***/ })
],[26]);


// WEBPACK FOOTER //
// client.fda1939e.js